import Module1 from '../Phone/Module1'
import Module2 from '../Phone/Module2'
import Module3 from '../Phone/Module3'
import Module5 from './Module5'
import FloatingElements from '../../FloatingElements'
import usePageContext from '../../Page/context'
import { useEffect, useState } from 'react'
import ModuleMedallistsPhase1_5 from '../Phone/ModuleMedallistsPhase1_5'
import ModuleMedallistsPhase2 from '../Phone/ModuleMedallistsPhase2'
import ModuleMedallistsPhase2_5 from '../Phone/ModuleMedallistsPhase3'
import ModuleMedallistsPhase3 from '../Phone/ModuleMedallistsPhase3'

const Desktop = (props: any) => {
  // Theme
  const {
    dispatch
  } = usePageContext()

  const [isThemeSet, setIsThemeSet] = useState(false)

  useEffect(() => {
    if (!isThemeSet) {
      dispatch({
        type: 'SET_THEME',
        payload: 'transparent'
      })
      setIsThemeSet(true)
    }
  }, [isThemeSet, dispatch])

  return (
    <>
      <Module1 {...props} />
      {props?.medallistBlock === 'phase1.5MedallistAnnounced' && <ModuleMedallistsPhase1_5 {...props} />}
      {props?.medallistBlock === 'phase2MedallistAnnounced' && <ModuleMedallistsPhase2 {...props} />}
      {props?.medallistBlock === 'phase2.5MedallistAnnounced' && <ModuleMedallistsPhase2_5 {...props} />}
      {props?.medallistBlock === 'phase3MedallistAnnounced' && <ModuleMedallistsPhase3 {...props} />}
      <Module2  {...props} />
      <Module3  {...props} />
      {/* <Module3Video /> */}
      {/* <Module4 /> */}
      <Module5  {...props} />
      <FloatingElements />
    </>
  )
}

export default Desktop
